import type { SelfServiceAPI } from 'types';
import type { Options } from '../types';
import api from 'lib/axios/api';
import handleServiceError from '../utils/handleServiceError';

export interface Params {
  limit: number;
  offset: number;
  filter: string;
}

interface RequestOptions extends Options {
  signal?: AbortSignal;
}

const getBookings = async (params: Params, options: RequestOptions = {}): Promise<SelfServiceAPI.GetBookings.Response> => {
  try {
    const { data } = await api.get('/bookings', { params, signal: options.signal });
    return data;
  } catch (error) {
    handleServiceError(error, {
      operationName: 'GET /bookings',
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getBookings;
